import { RevealText } from "./Reveal";

type Props = {
  eyebrow: string;
  title: string;
  accent?: string;
  align?: "left" | "center";
};

export function SectionHeading({ eyebrow, title, accent, align = "left" }: Props) {
  return (
    <div className={`mb-14 md:mb-20 ${align === "center" ? "text-center" : ""}`}>
      <div
        className={`mb-4 flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}
      >
        <span className="h-px w-8 bg-gradient-to-r from-primary to-transparent" />
        <span className="font-mono text-xs uppercase tracking-[0.35em] text-muted">
          {eyebrow}
        </span>
        {align === "center" && (
          <span className="h-px w-8 bg-gradient-to-l from-primary to-transparent" />
        )}
      </div>
      <h2 className="font-display text-4xl font-bold leading-tight tracking-tight text-white md:text-6xl">
        <RevealText text={title} />
        {accent && (
          <>
            {" "}
            <RevealText text={accent} className="text-gradient-animated" />
          </>
        )}
      </h2>
    </div>
  );
}
